import { render, staticRenderFns } from "./DuwaDeviations.vue?vue&type=template&id=aba4ff0e"
import script from "./DuwaDeviations.vue?vue&type=script&lang=js"
export * from "./DuwaDeviations.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports